const texts = {
  authorizationTabs: { signIn: "Se connecter", signUp: "S`inscrire" },
  general: {
    save: "Enregistrer",
    close: "Fermer",
    next: "Suivant",
    clearStep: "Effacer cette étape",
    tryAgain: "Essayez à nouveau",
    errorTitle: "Erreur",
    service: "Service ",
    message: "Message ",
    statusCode: "Code du statut ",
  },
  months: {
    "1": "Janvier",
    "2": "Février",
    "3": "Mars ",
    "4": "Avril ",
    "5": "Mai ",
    "6": "Juin ",
    "7": "Juillet ",
    "8": "Août ",
    "9": "Septembre ",
    "10": "Octobre ",
    "11": "Novembre ",
    "12": "Décembre ",
  },
  signIn: {
    title: "Bienvenue sur MultiMatch ",
    description: "Créez votre propre solution personnalisée de fertilisation à libération contrôlée (CRF). ",
    email: "E-mail ",
    password: "Mot de passe ",
    forgotPassword: "mot de passe oublié? ",
    keepMeLoggedIn: "Rester connecté(e) à partir de cet appareil ",
    keepMeLoggedInMobile: "Rester connecté(e) à partir de cet appareil ",
    emailApproved: "Votre courriel a été approuvé. Veuillez vous connecter pour continuer. ",
  },
  updatePassword: {
    title: "Définir un nouveau mot de passe ",
    description: "Votre mot de passe doit avoir  ",
    password: "Nouveau mot de passe ",
    confirmPassword: "Confirmer le mot de passe ",
    submitMessage: "Mettre à jour le mot de passe ",
    success: "Votre mot de passe a été modifié`, `redirection vers la page de connexion. ",
    UPDATE_PASSWORD_CONFIRMED: "Votre mot de passe a été confirmé avec succès  ",
    errors: {
      EMAIL_TOKEN_INVALID: "Votre code de réinitialisation du mot de passe n`est pas valide ",
      EMAIL_NOT_CONFIRMED: "Votre adresse électronique n`a pas été confirmée. ",
      MAIL_NOT_CONFIRMED: "Votre adresse électronique n`a pas été confirmée. ",
      PASSWORD_UPDATE_SUCCESS: "Votre mot de passe a été mis à jour ",
      PASSWORD_UPDATE_FAILED: "Votre mot de passe n`a pas été mis à jour ",
      TEMP: "Code invalide ou email non confirmé ",
    },
    sendEmail: "Nous vous avons envoyé un e-mail. Vérifiez votre boîte de réception.  ",
    errorPasswordRequired: "Le mot de passe et la confirmation du mot de passe ne doivent pas être vide.  ",
  },
  signUp: {
    note: "Inscrivez-vous pour sauvegarder vos informations en vue d`une utilisation ultérieure ",
    passwordNote: "Votre mot de passe doit comporter au moins 8 caractères`, `dont une lettre majuscule`, `une lettre minuscule et un chiffre. ",
    fullName: "Nom complet ",
    country: "Pays ",
    region: "Région ",
    email: "E-mail ",
    mainInterest: "Intérêt principal ",
    expertise: "Expertise ",
    password: "Mot de passe ",
    confirmPassword: "Confirmer le mot de passe ",
    iAccept: "J`accepte ",
    termsAndConditions: "les conditions générales de Haifa ",
    and: "et ",
    privacyPolicy: "Politique de confidentialité ",
    next: "Suivant ",
    emailSent: "Nous vous avons envoyé un e-mail à {0}\n" + ". Vérifiez votre boîte de réception.  ",
    didntGet: "Vous ne l`avez pas reçu ? ",
    checkBoxError: "Merci d`approuver ",
  },
  validationErrors: {
    fieldIsRequired: "Les champs obligatoires doivent être remplis ",
    incorrectEmailFormat: "L`adresse e-mail n`existe pas ",
    passwordValidation: "Mot de passe non valide ",
    passwordsDontMatch: "Les mots de passe ne correspondent pas ",
    lettersOnly: "Veuillez utiliser uniquement des lettres ",
    incorrectEmail: "Adresse e-mail incorrecte ",
    IncorrenctPassword: "Mot de passe incorrect ",
    emailExisted: "L`adresse e-mail existe déjà dans le système ",
    termsCheckbox: "Obligatoire ",
    minimumValue: "Value must be larger than {0}",
    valueOutOfRange: "La valeur doit être comprise entre {0} et {1} ",
    invalidDateFormat: "Veuillez indiquer une date valide ",
    dateMustBeGreater: "La date de récolte doit être postérieure à la date de la plantation ",
    dateMustBeAtLeastTwoMonths: "La date doit être d`au moins deux mois ",
    noServiceForSpecificCountry: "Aucun service n`est disponible pour le pays sélectionné ",
    dateMaxDatesTwelveMonth: "Le maximum est d`un an ",
  },
  errorMessages: {
    generic: "Une erreur s`est produite`,`veuillez réessayer plus tard ",
    LOGIN_FAILED: "Le nom d`utilisateur ou le mot de passe est incorrect ",
    MISSING_EMAIL: "L`adresse e-mail est obligatoire ",
    EMAIL_INVALID: "Adresse e-mail incorrecte ",
    DUPLICATEUSERNAME: "L`adresse e-mail existe déjà dans le système ",
    PASSWORD_INVALID: "Mot de passe non valide ",
    USERNAME_INVALID: "Le nom ne peut pas contenir de caractères spéciaux ou de chiffres ",
    SPECIALIZATION_INVALID: "Spécialisation non valide ",
    MAIN_INTEREST_INVALID: "Intérêt principal non valide ",
    REGION_INVALID: "Région non valide ",
    REGION_NOT_EXIST: "La région n`existe pas ",
    USER_NOT_FOUND: "L`utilisateur n`existe pas ",
    USER_ALREADY_EXIST: "Cet utilisateur existe déjà ",
    MISSING_VALUES_TO_CONFIRM_REGISTRATION: "L`enregistrement a échoué - il vous manque des valeurs ",
    EMAIL_SENT_TO_USER: "L`e-mail a été envoyé à l`utilisateur ",
    REGISTRATION_FAILED: "L`enregistrement a échoué ",
    TOKEN_INVALID: "Le code d`authentification n`est pas valide ",
    EMAIL_CONFIRMED_ALREADY: "L`adresse e-mail a déjà été confirmée ",
    NO_SOLUTION_MATCH: "Aucune solution prête à l`emploi n`a été trouvée ",
    EMAIL_CONFIRMED_SUCCESS: "L`adresse e-mail a été confirmée avec succès  ",
    VALIDATION_FAILED: "La validation a échoué ",
    ACCEPT_TERMS_INVALID: "Valeurs de validation non valides ",
    SAVING_ITEM_FAILED: "Enregistrement de l`élément impossible ",
    SAVED_ITEM_NOT_FOUND: "L`élément n`existe pas ",
    UPDATING_RECIPE_ITEM_FAILED: "Impossible de mettre à jour l`élément ",
    REMOVING_RECIPE_ITEMS_FAILED: "Impossible de supprimer l`élément de recette ",
    REMOVING_GRAPH_ITEMS_FAILED: "Impossible de supprimer un élément du graphique ",
    ITEM_UPDATED_SUCCESSFULLY: "L`élément a été mis à jour avec succès ",
    ITEM_DELETED_SUCCESSFULLY: "L`élément a bien été supprimé ",
    RAW_MATERIAL_PARAMETERS_NOT_VALID: "Impossible d`enregistrer une nouvelle matière première - Paramètres non valides ",
    SAVING_RAW_MATERIAL_FAILED: "Impossible d`enregistrer une nouvelle matière première ",
    RAW_MATERIAL_ALREADY_EXIST: "La matière première existe déjà ",
    REMOVING_ITEM_FAILED: "Impossible de supprimer un élément ",
    UPDATING_ITEMS_FAILED: "Erreur dans la mise à jour de l`élément dans la base de données ",
    CALCULATOR_IS_NOT_READY: "Chargement des données du calculateur... ",
    NUTRIENT_TYPE_INVALID: "Type de nutriment non valide ",
    BLEND_INVALID: "Mélange multicote non valide ",
    TYPE_INVALID: "type invalide pour l`une des propriétés ",
    MISSING_SAVED_ITEM_ID: "L`identifiant de l`élément enregistré manque dans la demande  ",
    ITEM_NOT_FOUND: "Article non trouvé ",
    RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "La recette ne peut avoir plus de 6 matières premières ",
    RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
      "La recette doit comprendre au moins une matière première enrobée et jusqu`à 5 matières non enrobées ",
    ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Un ou plusieurs ID de matières premières invalides dans la recette ",
    PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "Le pourcentage du mélange doit être de 100 % ",
    START_DATE_REQUIRED: "Date de début obligatoire ",
    END_DATE_REQUIRED: "Date de fin obligatoire ",
    END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "La date de fin doit être postérieure à la date de début ",
    YIELD_VALUE_REQUIRED: "Rendement obligatoire ",
    COUNTRY_INVALID: "Pays non valide ",
    CROP_CODE_INVALID: "Culture non valable ",
    MESUREMENTS_INVALID: "Unité de mesure non valide ",
    SOIL_AND_WATER_COMBINATION_INVALID: "Combinaison de sols et d`eau non valable ",
    MONTHS_AND_TEMPATURES_INVALID: "Les valeurs des mois et des températures ne sont pas valides ",
    shareWithNoSaving: " Désolé`, `je ne peux pas partager un élément non sauvegardé ",
    ITEM_NAME_TOO_SHORT: "nom trop court ",
    ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED ",
    ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED ",
    UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED ",
  },
  rightDrawer: {
    showMoreText: "Afficher",
    contactUs: "Contact us",
    findDealer: "Find a dealer",
  },
  fmSummary: {
    shortSummaryTitle1: "Cultures ",
    shortSummaryTitle2: "Sol ",
    shortSummaryTitle3: "Solution ",
    shortSummaryTitle4: "Exploitation ",
    shortSummaryTitleGraphPage: "Personnaliser ",
    ourProducts: "Nos produits ",
    summary: "Données collectées ",
    seeMoreProducts: "Voir d`autres produits Multicote™ ",
    recipeCoatedElements: "Éléments enrobés ",
    recipeUncoatedElements: "Éléments non enrobés ",
  },
  fmLeftMenu: {
    title: "MultiMatch ",
    subTitle: "Programmes personnalisés de nutrition planétaire ",
    menuLabels: {
      label0: "Shlomit Adary ",
      label1: "Multicote Agri Solution ",
      label2: "Solution Multicote  ",
      label3: "Éléments sauvegardés ",
      label4: "A propos  ",
      label5: "Nous contacter ",
    },
    logout: "Se déconnecter ",
  },
  steps: {
    cropsDesktop: "Cultures ",
    cropsMobile: "Caractéristiques de votre culture ",
    soilDesktop: "Sol ",
    soilMobile: "Températures et caractéristiques du sol ",
    resultsDesktop: "Résultats ",
    resultsMobile: "Résultats ",
    farmDesktop: "Exploitation (facultatif) ",
    farmMobile: "Pratique agricole (facultatif) ",
    customizeDesktop: "Personnaliser (facultatif) ",
    customizeMobile: "Créez votre propre mélange (facultatif) ",
  },
  agriSolution: {
    npkAlert: "NPK is Different from Crop Demand:",
    title: "Multicote Agri Solution ",
    selectCropLabel: "Sélectionnez votre culture ",
    expectedYieldLabel: "Rendement attendu ",
    plotSizeLabel: "Taille de la parcelle",
    plantingDateLabel: "Date des semis ",
    finalHarvestExpectedDate: "Date de récolte finale prévue ",
    selectPlotLocationLabel: "Sélectionnez l`emplacement de la parcelle ",
    selectPlotLocationNote: "Soyez le plus précis possible. Cela permet d`évaluer les données climatiques ",
    selectArea: "ou sélectionner une zone ",
    selectOrAddNew: "Sélectionner dans la liste ou ajouter un nouveau  ",
    onTheMap: "sur la carte  ",
    select: "Sélectionner ",
    selectSoilLabel: "Températures et caractéristiques du sol ",
    waterRegime: {
      title: "Sélectionner le régime d`eau ",
      description: "Quelles sont les conditions de précipitation dans la région ? ",
      sliderMarks: {
        "1": "Aride",
        "2": "Semi-aride",
        "3": "Semi-tropical",
        "4": "Tropical",
      },
    },
    soilType: {
      title: "Sélectionner le type de sol ",
      description: "Quel est le type de sol de la parcelle ? ",
      sliderMarks: {
        "1": "Sable, sable limoneux ",
        "2": "Moyennement sableux",
        "3": "Limon, limoneux, argile limoneuse",
        "4": "Limon argileux, argile",
      },
    },
    soilWarning:
      "Les besoins en nutriments sont basés sur le rendement attendu. Un programme de fertilisation Multicote est conçu pour remplacer tous les macro-nutriments que la culture éliminera. Le sol est considéré comme un tampon et la teneur en nutriments du sol n`est pas prise en compte. Une bonne pratique agricole consiste toutefois à prélever des échantillons de sol tous les 2 à 3 ans et à appliquer les modifications nécessaires en fonction de l`analyse du sol. Cela permettra de maintenir et d`améliorer la fertilité du sol au fil du temps. ",
  },
  fmDescriptionSnippet: {
    title: "Bienvenue dans le calculateur de solutions Multicote ",
    description:
      "Un logiciel basé sur le cloud pour créer votre propre solution personnalisée d`engrais à libération contrôlée pour les producteurs individuels ou les entreprise en quelques étapes faciles. ",
  },
  fmDropdownWithImg: { title: "Sélectionnez votre culture " },
  back: "Retour ",
  fmRecommendedProduct: {
    volume: "Volume d`application recommandé ",
    method: "méthode d`application ",
    link: "Cliquez pour obtenir un graphique de libération ",
  },
  pageStep1: {
    soilTemp: "Sélectionner la température du sol ",
    change: "Modifier ",
    'note," Veuillez sélectionner votre culture dans la liste et indiquer le rendement attendu': "la date des semis et la date finale de récolte. ",
    cfpTitle: "Carbon & Environmental footprint",
    cfpDesc: "assessment tool is now included in MultiMatch to help you improve your environmental impact",
    cfpButton: "Read More",
  },
  fertilizationPopup: {
    title: "Application de nutriments d`engrais ",
    subTitle: "Connaissez-vous vos niveaux actuels de nutriments totaux dans le cadre de votre pratique actuelle de fertilisation ? ",
    thirdTitle: " Sélectionnez `Je sais` ci-dessous pour calculer votre nouvelle formule personnalisée ",
    iKnow: "Je sais ",
    iDontKnow: "Je ne sais pas ",
    next: "Suivant ",
  },
  saveProcessPopup: {
    title: "Sauvegarder ce processus ",
    'subTitle," Nous avons remarqué que vous avez un processus non sauvegardé': "voulez-vous continuer ? ",
    dontShowThisMessage: "Ne plus afficher ",
    noThanks: "Non`, `merci ",
    save: "Enregistrer ",
  },
  clearStepPopup: {
    title: "Effacer cette étape ",
    subTitle: "Êtes-vous sûr de vouloir effacer vos données de cette étape ? ",
    dontShowThisMessage: "Ne plus afficher ",
    noGoBack: "Retour ",
    clear: "Effacer mes données ",
  },
  deleteItemPopup: {
    title: "Supprimer l`élément ",
    subTitle: "Êtes-vous sûr de vouloir supprimer cet élément ? ",
    no: "Non ",
    yes: "Oui ",
  },
  saveItemPopup: {
    title: "Sauvegarder la solution ",
    label1: "Nom de la solution ",
    label2: "Zone ",
    getBack: "J`aimerais qu`un agronome de Haifa examine ma sélection et qu`il me recontacte. ",
    save: "Enregistrer ",
    snackbar: "Elément enregistré ",
  },
  pageStep4: {
    title: "Pratique agricole ",
    table: {
      nutrients: "Nutriments ",
      nutrientsUnit: "(kg/ha) ",
      label1: "Pratique de l`exploitant ",
      label2: "Demande de récoltes ",
      label3: "Sauvegarder des nutriments de l`environnement ",
    },
    question: "Quelles sont vos habitudes ? ",
    questionDescription:
      "Si vous utilisez déjà certains engrais qui produisent des rendements normaux`, `veuillez nous fournir le total des NPK appliqués par saison. Nous utiliserons ces taux pour calculer les taux optimaux de Multicote pour votre formule personnalisée. ",
    fill: "Illustrer vos pratiques ",
    buttomDescription:
      "Grâce à l`utilisation de Multicote`, `l`efficacité de l`utilisation des nutriments enrobés est considérablement améliorée. Cela nous permet de réduire la quantité totale de nutriments appliqués`, `réduisant ainsi la pollution des eaux souterraines et l`accumulation de concentrations indésirables de sel dans le sol. ",
    warningText1: "Nous conseillons de contacter un ",
    warningText2: "Agronome professionnel ou distributeur de Haifa ",
    warningText3: "pour confirmer votre sélection avant de procéder. ",
    clearThisStep: "Effacer cette étape ",
    cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint ",
    next: "Suivant ",
    save: "Enregistrer ",
  },
  multicoteTable: { mesurmentUnit: "(%) " },
  mainInterests: { OFA: "Agriculture de plein champ ", N: "Pépinière " },
  metricMethods: { "1": "métrique ", "2": "impérial " },
  specialties: {
    "1": "Jardinage - un passe-temps ",
    "2": "Cultivateur ",
    "3": "Contractant agricole ",
    "4": "Formation agricole - Services ",
    "5": "Commerce ",
    "6": "Autre ",
  },
  PageReleaseChart: {
    greenMessage: {
      title1: "MODE D`EMPLOI ",
      description1: "Appliquer toujours les mélanges de produits Multicote au niveau des racines ",
      description2: " Pour un rendement optimal`, `il doit être recouvert de terre ou de paillis ",
      subTitle: "Meilleure pratique  ",
      description3:
        " Appliquer en ligne pendant le semis. 2e meilleur`, `répartir uniformément avant la culture et incorporer les mélanges Multicote dans le lit de semence. ",
      title2: "QUAND ",
      description4: " Lors de l`ensemencement ou de la préparation de la parcelle`, `mais pas plus de 2 semaines avant la plantation. ",
      title3: "COMBIEN ",
      description5:
        " La technologie Multicote peut être utilisée en toute sécurité`, `mais pour une meilleure pratique`, `assurez-vous que les machines sont correctement calibrées. ",
      title4: "COURBE DE LIBÉRATION ",
      description6: "La courbe de libération indique la libération des nutriments en fonction de la température prévue du sol. ",
      radioButtonLabel: "Choisir un thème ",
      shareUnsavedItem: " Désolé`, `je ne peux pas partager un élément non sauvegardé ",
    },
    currentDayRemainingReleaseValues: {
      preValue: "Mois ",
      postValue: "NPK restant  ",
      currentPrecentage: "Remaining NPK (Percentage):",
      Percentage: "(Percentage)",
    },
    sendToAgronomist: {
      preUserName: "Utilisateur ",
      preCrop: "prévoit une solution pour la culture ",
      preYield: "avec un rendement attendu de ",
      preStartingDate: "Date de début  ",
      preFinalDate: "Date de fin  ",
      preSolutionName: "Solution  ",
      preVolumeApplication: "Application du volume  ",
    },
    warning: {
      description: "Une application supplémentaire des éléments secondaires et micro sera nécessaire. Pour une recommandation complète ",
      boldDescription: "Contacter votre agronome ou distributeur local de Haifa. ",
    },
    buttons: {
      downloadFile: "Télécharger le PDF ",
      sendToPro: "Envoyer à l`agronome ",
      shareLink: {
        desktop: "Partager le lien",
        mobile: "Partager",
      },
    },
  },
  wideTable: {
    kodkod: {
      title1: "Libération / Sortie du matériel  ",
      title2: "par mois (Kg/Ha) ",
    },
    sideLabel: { label1: "N (var) ", label2: "P ", label2_1: "O ", label3: "K " },
    months: {
      month1: "Janvier ",
      month2: "Février ",
      month3: "Mars ",
      month4: "Avril ",
      month5: "Mai ",
      month6: "Juin ",
      month7: "Juillet ",
      month8: "Août ",
      month9: "Septembre ",
      month10: "Octobre ",
      month11: "Novembre ",
      month12: "Décembre ",
    },
    caroselHeader: { title: "Libération mensuelle (%) " },
    next: "Suivant ",
    back: "Retour ",
  },
  saveItemsPage: {
    title: "Solutions sauvegardées ",
    inputPlaceholder: "Saisir un type de culture ou une zone pour trouver vos mélanges enregistrés ",
    mobile_inputPlaceholder: "Saisir un type de culture ou une zone ",
    clearAll: "Tout effacer ",
    loadMore: "Charger davantage ",
    savedItemCard: {
      rename: "Renommer ",
      delete: "Supprimer ",
      duplicate: "Dupliquer ",
      contact: "Contacter ",
      showTo: "Montrer l`élément à l`agronome de Haifa ",
    },
  },
  multicoteSolutionPage: {
    stepOne: {
      firstInput: "Choisir un mélange ",
      secondInput: "Date de début ",
      radioLabel1: "P2O5 K20 ",
      radioLabel2: "PK ",
      selectTemperature: "Sélectionner la température ",
      calculateButton: "Calculer ",
      setTempratureButton: "Définir les températures ",
    },
    title: "Solution Multicote  ",
    changeCalculationSetting: "Modifier le paramètre de calcul ",
    save: "Enregistrer ",
    line: "Ligne ",
    bar: "Barre ",
    graphCodCodTitle: "Libération importante ",
  },
  pageStep3: {
    carbonFootprintLoadingText: "Veuillez ne pas fermer cette fenêtre",
    carbonFootprintDesc: "Évaluation de l'empreinte environnementale et carbone pour l'ensemble du cycle de culture",
    carbonFootprintButtonText: "Calculate for me!",
    subTitle: "Votre recommandation ",
    customize: {
      bestSuit: "La formule la mieux adaptée ",
      subDescription: "Nous avons trouvé cette formule pour répondre au mieux aux besoins de votre culture ",
      title: "Vous voulez ajuster la formule ? ",
      secondSubDescription:
        "Vous pouvez soit ajuster cette formule`, `soit créer la vôtre pour l`adapter à vos conditions locales en quelques étapes simples. ",
      button: "Ajuster la formule  ",
      topLink: "Graphique de libération ",
    },
    bottomTitle: "Formule toute faite ",
    bottomDescriptionWithMatch: "C`est la formule toute prête la plus recommandée et similaire à votre recommandation ",
    bottomDescriptionWithoutMatch: " Nous n`avons pas trouvé de formule adaptée aux besoins de votre culture`, `aux conditions du sol et du climat ",
    recommendedProduct: {
      description:
        " Notre recommandation est basée sur les besoins des cultures en NPK uniquement`, `en fonction de la demande connue de ces nutriments Les applications d`éléments secondaires et d`oligo-éléments seront effectuées en fonction de l`analyse du sol et des besoins de la culture ",
    },
    save: "Enregistrer ",
    inSoil: "Dans le sol ",
    metric: "kg/ha ",
    imperial: "ST/Acre ",
  },
  pageStep5: {
    title: "Créez votre propre mélange ",
    updateButton: "Mise à jour du calcul de N`, P`, K ",
    recipeValidationError: "La recette doit comporter au minimum 1 produit enduit et au maximum 6 éléments au total ",
    save: "Enregistrer ",
    bestSolution: "Meilleure solution ",
    subTitle1: "Sélectionner jusqu`à 6 éléments au total ",
    coated: "Enrobé ",
    uncoated: "Non enrobé ",
    completePercentage: "Pourcentage complété de votre mélange Multicote  ",
    missing: "manquant ",
    clear: "Effacer cette étape ",
    continueButton: "Continuer vers le graphique des versions ",
    bottomDrawer: {
      savedItem: "Éléments sauvegardés ",
      rename: "Renommer ",
      delete: "Supprimer ",
      reset: "Réinitialiser ",
      update: "Mettre à jour ",
    },
    uncoatedHelperText: " ",
    updateCard: {
      leftSpan: "N`, P`, K calculés en fonction de votre sélection de matériaux:",
      errorMessage: {
        missingWord: "Increase",
        extraWord: "Decrease",
        rightPart: "% for calculation",
      },
    },
  },
  userAreaPage: {
    title: "Mon profil ",
    tab1: "Profil utilisateur ",
    tab2: "Ma banque de matières premières ",
    inputLabel1: "Nom complet ",
    inputLabel2: "Pays ",
    inputLabel3: "E-mail ",
    inputLabel4: "Intérêt principal ",
    inputLabel5: "Expertise (facultatif) ",
    button: "Mettre à jour ",
    inputSecondPage: "Non enrobé ",
    messages: { success: "Profil mis à jour avec succès  " },
    uncoatedInputHelperText: " ",
  },
  contactUs: {
    title: "Vous avez une question ? Vous avez besoin d`un conseil ? ",
    secondTitle: " merci de votre visiter sur notre plateforme ",
    description:
      "Nous sommes heureux de répondre à toutes vos questions et nous aimerions connaître votre expérience afin de pouvoir continuer à améliorer nos offres. ",
    inputLabel1: "Pays ",
    inputLabel2: "Région ",
    inputLabel3: "Position ",
    inputLabel4: "Méthode de production ",
    inputLabel5: "Numéro de téléphone portable ",
    inputLabel6: "Superficie (ha) ",
    inputLabel7: "Adresse e‑mail ",
    inputLabel8: "Votre message ",
    back: "Retour ",
    send: "Envoyer ",
    messages: {
      success: "Merci pour votre e-mail. Nous vous répondrons bientôt. ",
      invalidPhoneNumber: "Numéro de téléphone portable non valide ",
    },
  },
  PDFfile: {
    mateData: {
      createdBy: "Créé par  ",
      name: "Nom  ",
      location: "Lieu  ",
      phoneNumber: "Numéro de téléphone  ",
      Date: "Date  ",
      Time: "Heure  ",
    },
    summaryData: {
      nutrientsApplied: "Nutriments appliqués",
      collectedDataTitle: "Données collectées  ",
      cropsTitle: "Cultures  ",
      cropProp: "Culture  ",
      yieldProp: "Rendement  ",
      plotSize: "Plot Size",
      plantingDateProp: "Date des semis",
      harvestDateProp: "Date de la récolte  ",
      soilTitle: "Sol ",
      WaterRegimeProp: "Régime d`eau  ",
      soilProp: "Sol",
      customizedTitle: "Personnalisé ",
      recipeCoatedTitle: "Éléments enrobés ",
      recipeUncoatedTitle: "Éléments non enrobés ",
      recommended: "Recommandé ",
      MaterialCodeProp: "Code matériel",
    },
    waver: {
      title: "AVERTISSEMENT ",
      body: {
        before: "Before using, the grower shall determine the suitability of the product for his intended use.",
        theGrower: "The grower assumes all risk and liability for consequential and incidental damages. This product",
        isSold: "is sold without warranty of any kind, expressed or implied, as to  its merchantability",
        orFitness: " or fitness for a particular purpose.",
        caution: "Caution: ",
        harmful: "Harmful is swallowed. Keep out of reach of children. Store under cool, dry conditions.",
      },
    },
    descriptionRecommended:
      "Notre recommandation est basée sur les besoins des cultures en NPK uniquement`, `en fonction de la demande\nconnue de ces nutriments Les applications d`éléments secondaires et d`oligo-éléments seront effectuées en fonction\nde l`analyse du sol et des besoins de la culture. ",
    howToUse: {
      title: "MODE D`EMPLOI ",
      body: {
        firstLine: "Always apply Multicote products blends at the root zone.",
        secondLine: "For optimal performance, it must be covered with a few centimeters of soil",
        thirdLine: "or mulch.",
        fourthLinePartOne: "Best practice:",
        fourthLinePartTwo: "Apply in row while seeding.",
        fifthLinePartOne: "2nd best:",
        fifthLinePartTwo: "Spread evenly before cultivation and incorporate the Multicote™",
        fifthLinePartThree: "blends into the seedbed.",
        forOptimalPerformance: "For optimal performance, mix Multicote™ with potting soil before planting.",
        mixMulticote: " Mix Multicote™ with potting soil before planting.",
        secondBestPractice: "2nd best practice - Dibbling:",
        forLate: "for late application, make holes around the plant and apply ,Multicote™",
        evenly: "evenly, cover with soil.",
      },
    },
    when: {
      title: "QUAND ",
      body: {
        firstLine: "While seeding or at plot preparation, but not more than 2 weeks prior to ",
        secondLine: "planting. ",
      },
    },
    howMuch: {
      title: "COMBIEN ",
      body: {
        firstLine: "Multicote™ technology is safe for use, but for best practice make sure",
        secondLine: "machinery is correctly calibrated.",
      },
    },
    releaseCurve: {
      title: "COURBE DE LIBÉRATION ",
      body: "La courbe de libération indique la libération des nutriments en fonction de la température prévue du sol ",
    },
    nameOfFile: "Multicote™ - Our Solution.pdf ",
  },
  ShareEmail: {
    title: "Instructions ",
    body: {
      please: "Veuillez ",
      find: "trouver ",
      attached: "en pièce jointe ",
      recommendation: "nos recommandations ",
      Thank: "Merci ",
      you: "à vous ",
      Haifa: "Haifa ",
      Group: "Groupe ",
    },
  },
  autoCompleteInput: {
    firstSpan: "Ces valeurs ne sont pas valides ",
    secondSpan: "max N, P, K sont 46, 54, 62 ",
    thirdSpan: "La somme maximale est de 66 ",
    noOptions: "Aucune option ",
  },
  sideMenu: {
    termsAndCondition: {
      title: "Modalités et conditions  ",
      contentTitle: "Conditions d`utilisation  ",
    },
    privacyPolicy: { title: "Politique de confidentialité " },
    copyRightTitle: "Droits d`auteur 2021 Haifa ",
    poweredBy: "Alimenté par ",
  },
  cfpTable: {
    savingTitle: "Économie d'éq. CO2",
    reducedCo2: "Par",
    reducedCo2PerPlot: "Par parcelle",
    rating: {
      excellent: "Excellent",
      worse: "Pire",
    },
    tableColumns: {
      envParams: "Paramètres environnementaux",
      multiTech: "Technologie Multicote™",
      tradTech: "Application traditionnelle",
      performanceRating: "Performance de l'évaluation de la technologie Multicote™",
      index: "Indice",
    },
    tableRows: {
      carbonFootprint: {
        label: "Empreinte carbone",
        measureUnit: "kg CO2 eq./kg produit",
      },
      nLeaching: {
        label: "Lessivage de l'azote",
        measureUnit: "kg NO3/kg produit",
      },
      nRunOff: {
        label: "écoulement d’azote",
        measureUnit: "kg NO3/kg produit",
      },
      nVolatilization: {
        label: "Volatilisation de l'azote",
        measureUnit: "kg NH3/kg produit",
      },
      terrestrialEutrophication: {
        label: "Eutrophisation terrestre",
        measureUnit: "kg P eq./kg produit",
      },
    },
    carbonBannerTitle: "Calcul de l'économie de carbone",
    carbonBannerText: "((Empreinte carbone de l'application traditionnelle)/ha - (Empreinte carbone de la technologie Multicote™)/ha) X Rendement attendu T/Ha)",
  },
};
export default texts;
